<container kind="midi">
  <page-intro-header
    title="{{ 'NEW_LEGAL_SUBJECT.TITLE' | translate }}"
    back="/legal_subjects"
  >
  </page-intro-header>
  <mat-card class="card">
    <legal-subject-form></legal-subject-form>
  </mat-card>
</container>